// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionContentsBody_content__1BZ9x","content--body":"SectionContentsBody_content--body__EiytR"};